<template>
  <v-card
    class="all my-16 py-4 px-16 "
    color="white"
    elevation="0"
  >
  <div class="text-center">
    <div class="title1 my-8">SMS認証が完了しました</div>
    <div class="pt-6 pb-8 text-h5 my-16 font-weight-bold">
      SMS認証による本人確認が完了しました<br>そのままアカウント作成画面へお進みください
    </div>
    <v-btn
      class="back my-8"
      color="black"
      text
      large
      href="/signup"
      >
      <div style="font-size:36px">
        <span style="color:#008CFF">＜</span>アカウント作成へ<span style="color:#008CFF">＞</span>
      </div>
    </v-btn>

   
  </div>

    
  </v-card>
</template>

<script>
export default {
  data: () => ({

  }),
  name: 'smsfinish'
}
</script>

<style scoped>
.all{
  position: fixed;
  top:10%;
  left: 25%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 35px;
}
*{
  font-family:mplus-2c-medium;
}



</style>
